// src/utils/carousel.js
//
// Shared horizontal-scroll tuning for movie-row carousels (.movie-grid).
// Keep in sync with MovieCard.css's .movie-card width (210px) + margin (8px * 2).
export const CARD_STEP = 226;

const MOBILE_BREAKPOINT = 480;
const TABLET_BREAKPOINT = 768;

// How many cards the right arrow advances per click — fewer on smaller
// screens, where 5 cards is most (or all) of what's visible at once.
export function getCardsPerScroll() {
  if (typeof window === 'undefined') return 5;
  const width = window.innerWidth;
  if (width <= MOBILE_BREAKPOINT) return 1;
  if (width <= TABLET_BREAKPOINT) return 2;
  return 5;
}
